export default function getNextActivityPage(events, itemsByPage) {
  return Math.floor(events.length / itemsByPage) + 1;
}
